// src/pages/personal/platforms/ClientsPage.tsx
import React from 'react';
import { AdaptiveLayout } from '@/components/ui/Layout';
import ClientsSection from './ClientsSection/ClientsSection';

const ClientsPage: React.FC = () => {
  return (
    <AdaptiveLayout>
      <ClientsSection />
    </AdaptiveLayout>
  );
};

export default ClientsPage;